const Twitter = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      opacity="0.25"
      x="1.22726"
      y="0.562521"
      width="28.125"
      height="28.1261"
      rx="14.0625"
      stroke="white"
      strokeWidth="1.12504"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1494 12.6939L15.1705 13.0508L14.8182 13.0071C13.5359 12.8396 12.4157 12.2715 11.4645 11.3174L10.9995 10.844L10.8797 11.1936C10.626 11.9729 10.7881 12.7959 11.3165 13.3494C11.5984 13.6553 11.5349 13.699 11.0488 13.5169C10.8797 13.4587 10.7317 13.415 10.7176 13.4368C10.6683 13.4878 10.8374 14.1506 10.9713 14.4128C11.1545 14.7769 11.5279 15.1338 11.9365 15.345L12.2818 15.5125L11.8731 15.5198C11.4786 15.5198 11.4645 15.5271 11.5068 15.68C11.6477 16.1535 12.2043 16.656 12.8243 16.8745L13.2611 17.0274L12.8807 17.2605C12.317 17.5955 11.6547 17.7849 10.9924 17.7995C10.6754 17.8067 10.4147 17.8359 10.4147 17.8577C10.4147 17.9306 11.2743 18.3384 11.7745 18.4986C13.2752 18.9721 15.0578 18.7681 16.3965 17.9597C17.3477 17.3843 18.2988 16.2409 18.7427 15.1338C18.9823 14.5439 19.2218 13.466 19.2218 12.9488C19.2218 12.6138 19.243 12.5701 19.6375 12.1695C19.87 11.9365 20.0884 11.6816 20.1307 11.6087C20.2012 11.4704 20.1941 11.4704 19.8348 11.5942C19.2359 11.8127 19.1514 11.7835 19.4473 11.4558C19.6657 11.2227 19.9264 10.8003 19.9264 10.6765C19.9264 10.6546 19.8207 10.6911 19.7009 10.7566C19.5741 10.8294 19.2923 10.9387 19.0809 11.0042L18.7004 11.128L18.3552 10.8877C18.165 10.7566 17.8972 10.6109 17.7563 10.5672C17.397 10.4653 16.8474 10.4798 16.5233 10.5964C15.6426 10.9241 15.086 11.769 15.1494 12.6939Z"
      fill="white"
    />
  </svg>
)

export default Twitter
